/** @format */

import * as React from "react";
import { Flex, Link, Image, Text, useMediaQuery } from "@chakra-ui/react";
import { commonInfo } from "@common/index";
import colors from "@src/style/colors";
import theme from "@src/style/theme";
import DOMPurify from "dompurify";

export const About_Partner_KR: React.FC = () => {
  const sanitizer = DOMPurify.sanitize;
  const basePaddingX = {
    base: "20px",
    sm: "20px",
    md: "65px",
    lg: "108px"
  };
  const basePaddingY = {
    base: "50px",
    sm: "70px",
    md: "80px",
    lg: "100px"
  };
  return (
    <Flex
      position={"static"}
      width={"100%"}
      flexDirection={"column"}
      justifyContent={"center"}
      alignItems={"center"}
      backgroundColor={colors.newGray}
      paddingX={{
        base: "20px",
        sm: "20px",
        md: "65px",
        lg: "108px",
        xl: "122px"
      }}
      paddingY={{
        base: "50px",
        sm: "70px",
        md: "80px",
        lg: "100px"
      }}>
      <Flex
        flexDirection={"column"}
        justifyContent={"center"}
        alignItems={"center"}
        maxWidth={theme.breakpoints.mx}
        width={"100%"}>
        <Text
          wordBreak={"keep-all"}
          fontSize={{
            base: "14px",
            sm: "18px",
            md: "24px",
            lg: "32px"
          }}
          fontWeight={"700"}
          pb={{
            base: "20px",
            sm: "40px"
          }}
          color={colors.coolGray200}>
          {commonInfo.about_partner.title}
        </Text>
        <Flex
          flexDirection={"row"}
          wrap={"wrap"}
          justifyContent={"space-around"}
          alignItems={"center"}
          gap={"20px"}
          pt={"20px"}>
          {commonInfo.about_partner.items.map((item, index) => (
            <Link
              href={item.url}
              flexBasis={"calc(100%/4 - 20px)"}
              width={"10vw"}
              isExternal
              key={index}>
              <Image
                objectFit={"contain"}
                src={item.image}
                align={"center"}
                fallbackSrc="https://via.placeholder.com/250x90"
              />
            </Link>
          ))}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default About_Partner_KR;
